export const pdfs = {
    isPending: false,
    error: null,
};
